import React from "react";
import Link from "src/components/link";
import ImageV2 from "src/components/image/image.v2";

type LogoProps = {
    className?: string;
    id: string;
    link?: string;
    logo: TImage;
}

export default class LogoImage extends React.Component<LogoProps> {

    get isSvg() {
        return this.props.logo.type?.indexOf("svg") !== -1;
    }

    render() {
        return <Link href={this.props.link} title={this.props.link} className={`flex h-[60px] max-w-full items-center overflow-hidden ${this.props.className || ''}`}>
            <ImageV2 
                imageFormat={this.isSvg ? undefined : "png"} 
                useImageKit={!this.isSvg} 
                asSvgIcon={this.isSvg}
                width={250} 
                height={60}
                className="max-h-[60px] max-w-[250px] max-h-full max-w-full object-contain"
                style={{objectFit: 'contain', objectPosition: 'center'}} 
                src={this.props.logo.imageFile}
                notMapSvg={true}
            />
        </Link>;
    }

}